/* src/core/components/memory-usage-div/memory-usage-div.component.scss */
.debug {
  display: block;
  position: absolute;
  top: 5px;
  right: 5px;
  width: auto;
  max-width: 85%;
  height: auto;
  border: white thin solid;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  z-index: 10000;
}
/*# sourceMappingURL=memory-usage-div.component.css.map */
